import * as React from "react";

function XIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M24 0v24H0V0h24zM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018zm.265-.113l-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022zm-.715.002a.023.023 0 00-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092z" />
        <path
          fill="currentColor"
          d="M12 14.121l5.303 5.304a1.5 1.5 0 002.122-2.122L14.12 12l5.304-5.303a1.5 1.5 0 10-2.122-2.121L12 9.879 6.697 4.576a1.5 1.5 0 10-2.122 2.12L9.88 12l-5.304 5.303a1.5 1.5 0 102.122 2.122L12 14.12z"
        />
      </g>
    </svg>
  );
}

export default XIcon;
